import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const CalculatorOutlineIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 20 20" fill="none" {...props}>
      {/* Outer rounded rectangle */}
      <path
        d="M0.833333 17.5V2.5C0.833333 1.57952 1.57952 0.833333 2.5 0.833333H17.5C18.4205 0.833333 19.1667 1.57952 19.1667 2.5V17.5C19.1667 18.4205 18.4205 19.1667 17.5 19.1667H2.5C1.57952 19.1667 0.833333 18.4205 0.833333 17.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      {/* Top-right horizontal lines */}
      <path
        d="M12.5 5.83333H14.1667H15.8333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.9167H14.1667H15.8333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 15.4167H14.1667H15.8333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Plus sign (top-left) */}
      <path
        d="M4.16667 5.83333H5.83333M5.83333 5.83333H7.5M5.83333 5.83333V4.16667M5.83333 5.83333V7.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Cross/multiply sign (bottom-left) */}
      <path
        d="M4.65515 15.3452L5.83366 14.1667M5.83366 14.1667L7.01218 12.9882M5.83366 14.1667L4.65515 12.9882M5.83366 14.1667L7.01218 15.3452"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
